/* eslint-disable indent */
import React, { Ref } from 'react';
import { EpInput, EpInputProps } from '../EpInput';

import './EpAuthenticator.scss';

export interface EpAuthenticatorProps extends EpInputProps {
  authenticatorId: string;
  authenticatorName: string;
  authenticatorAriaDescribedby?: string;
  authenticatorMaxValue?: number;
  authenticatorWithError?: boolean;
  authenticatorIsSuccessful?: boolean;
  customClasses?: string;
  authenticatorRef?: Ref<HTMLInputElement>;
}

export const EpAuthenticator: React.FC<EpAuthenticatorProps> = ({
  authenticatorId,
  authenticatorName,
  authenticatorAriaDescribedby,
  authenticatorMaxValue,
  authenticatorWithError = false,
  authenticatorIsSuccessful = false,
  customClasses,
  authenticatorRef,
  ...props
}) => {
  const authenticatorClassName = `ep-authenticator ${authenticatorIsSuccessful ? 'ep-authenticator--successful' : ''
    } ${authenticatorWithError ? 'ep-authenticator--with-error' : ''}`;

  return (
    <div className={authenticatorClassName}>
      <EpInput
        {...props}
        //@TODO - corrigir EpInput para não ter width numérico apenas
        inputWidth={137}
        inputId={authenticatorId}
        inputType="text"
        inputName={authenticatorName}
        inputAriaDescribedby={authenticatorAriaDescribedby}
        inputMaxValue={authenticatorMaxValue}
        inputMinLength={0}
        inputMaxLength={1}
        inputWithError={authenticatorWithError}
        inputAutocomplete="off"
        inputPlaceholder="0"
        className="ep-input ep-input--full-width ep-input--md"
        inputSize="md"
        ref={authenticatorRef}
        {...(customClasses && { className: `ep-input ${customClasses}` })}
      />
    </div>
  );
};
